module.exports = function() {
  return new Worker("/" + "babel-transpiler.5cc86523.worker.js");
};